import * as Yup from 'yup';

import { phoneRegex } from '@/tools/forms';

import { IFormMetadataProps, IFormProps } from '../types';

export const validationSchema = Yup.object().shape({
  firstName: Yup.string().required('First Name is required'),
  lastName: Yup.string().required('Last Name is required'),
  phone: Yup.string().required('Phone is required').matches(phoneRegex, 'Please enter a valid phone number.'),
  email: Yup.string().email().required('Email is required'),
  year: Yup.string().optional(),
  make: Yup.string().optional(),
  model: Yup.string().optional(),
  vin: Yup.string().optional(),
  serviceCenter: Yup.string().required('Service Center is required'),
  comments: Yup.string().optional(),
});

export interface IFormSchema extends IFormProps, IFormMetadataProps {
  serviceCenter: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  year: string;
  model: string;
  make: string;
  vin: string;
  comments: string;
  subscribe?: boolean;
  smsOptIn?: boolean;
}
